import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'

interface CookieConsentState {
  hasConsented: boolean
  functionalAccepted: boolean
  analyticsAccepted: boolean
  consentDate: string | null
  acceptAll: () => void
  acceptFunctional: () => void
  rejectAll: () => void
}

// Google Analytics consent management
const updateGoogleConsent = (analyticsAccepted: boolean) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('consent', 'update', {
      analytics_storage: analyticsAccepted ? 'granted' : 'denied',
    })
  }
}

export const useCookieConsent = create<CookieConsentState>()(
  persist(
    (set) => ({
      hasConsented: false,
      functionalAccepted: false,
      analyticsAccepted: false,
      consentDate: null,

      acceptAll: () => {
        set({
          hasConsented: true,
          functionalAccepted: true,
          analyticsAccepted: true,
          consentDate: new Date().toISOString(),
        })
        updateGoogleConsent(true)
      },

      acceptFunctional: () => {
        set({
          hasConsented: true,
          functionalAccepted: true,
          analyticsAccepted: false,
          consentDate: new Date().toISOString(),
        })
        updateGoogleConsent(false)
      },

      rejectAll: () => {
        set({
          hasConsented: true,
          functionalAccepted: false,
          analyticsAccepted: false,
          consentDate: new Date().toISOString(),
        })
        // Clear theme preference if exists
        localStorage.removeItem('ecosemantic-theme')
        updateGoogleConsent(false)
      },
    }),
    {
      name: 'ecosemantic-cookie-consent',
      storage: createJSONStorage(() => localStorage),
    },
  ),
)

// TypeScript declaration for gtag
declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void
    dataLayer?: unknown[]
  }
}
